import { useCallback, useRef } from 'react';

const useFacebookPixel = () => {
  const pixelRef = useRef(null);
  const initPromiseRef = useRef(null);

  const initializePixel = useCallback(async () => {
    if (!initPromiseRef.current) {
      initPromiseRef.current = (async () => {
        try {
          const module = await import('react-facebook-pixel');
          const ReactPixel = module.default;

          ReactPixel.init(process.env.REACT_APP_PIXEL_ID, undefined, {
            autoConfig: true,
            debug: true,
          });

          pixelRef.current = ReactPixel;
        } catch (error) {
          console.error('Facebook Pixel initialization failed:', error);
          initPromiseRef.current = null; // Reset to allow retry
          throw error;
        }
      })();
    }
    await initPromiseRef.current;
  }, []);

  const pageView = useCallback(async () => {
    try {
      await initializePixel();
      if (pixelRef.current) {
        await pixelRef.current.pageView();
      }
    } catch (error) {
      console.error('Facebook Pixel pageView failed:', error);
    }
  }, [initializePixel]);

  const track = useCallback(async (event, data = {}) => {
    try {
      await initializePixel();
      if (pixelRef.current) {
        await pixelRef.current.track(event, data);
      }
    } catch (error) {
      console.error('Facebook Pixel trackCustom failed:', error);
    }
  }, [initializePixel]);

  const trackCustom = useCallback(async (event, data = {}) => {
    try {
      await initializePixel();
      if (pixelRef.current) {
        await pixelRef.current.trackCustom(event, data);
      }
    } catch (error) {
      console.error('Facebook Pixel trackCustom failed:', error);
    }
  }, [initializePixel]);

  return {
    pageView,
    track,
    trackCustom,
  };
};

export default useFacebookPixel;
